import React, { type ReactElement, type ReactNode } from 'react';

import classnames from 'classnames';

import styles from './Container.module.scss';

type ContainerProps = {
    className?: string;
    children: ReactNode;
};

const Container = ({ className, children }: ContainerProps): ReactElement => {
    const containerClassNames = classnames(styles.container, className);

    return <div className={containerClassNames}>{children}</div>;
};

export default Container;
